export default __webpack_public_path__ + "static/media/skelly_0005.ee29fcab.png";